import * as Yup from 'yup';

export const uploadFormValidation = () => {
  return Yup.object().shape({
    description: Yup.string(),
    image: Yup.mixed().required('required'),
  });
};
